// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3COch","content":"LayoutSettings_content__2V8zt"};